import { PlusOutlined } from '@ant-design/icons';
import * as Antd from 'antd';
import {
    Link,
    type To,
} from 'react-router-dom';

import { getActionControlStyleVars } from './actionControlStyles';

type CreateButtonProps = {
    label: string;
    onClick?: () => void;
    disabled?: boolean;
    to?: To;
};

export const CreateButton = ({
    label,
    onClick,
    disabled = false,
    to,
}: CreateButtonProps) => {
    const { token } = Antd.theme.useToken();
    const styleVars = getActionControlStyleVars(token, {
        variant: 'primary',
        bordered: true,
        iconOnly: false,
        disabled,
    });
    const icon = <PlusOutlined />;

    if (to && !disabled) {
        return (
            <Link
                to={to}
                aria-label={label}
                className="app-action-control"
                style={styleVars}
            >
                {icon}
                {label}
            </Link>
        );
    }

    return (
        <Antd.Button
            type="primary"
            className="app-action-control"
            style={styleVars}
            icon={icon}
            onClick={onClick}
            disabled={disabled}
        >
            {label}
        </Antd.Button>
    );
};
